import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/events_analytics_events.py
export const EVENTS_ANALYTICS_ACTIONS = {
  CREATED_EVENT_SUBSCRIPTION: {
    module: ANALYTICS_MODULE.EVENTS,
    action: 'created_event_subscription',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_EVENT_SUBSCRIPTION: {
    module: ANALYTICS_MODULE.EVENTS,
    action: 'updated_event_subscription',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETED_EVENT_SUBSCRIPTION: {
    module: ANALYTICS_MODULE.EVENTS,
    action: 'deleted_event_subscription',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  INVALID_EVENT_SUBSCRIPTION_ATTEMPT: {
    module: ANALYTICS_MODULE.EVENTS,
    action: 'invalid_event_subscription_attempt',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  EXPIRED_EVENT_SUBSCRIPTION: {
    module: ANALYTICS_MODULE.EVENTS,
    action: 'expired_event_subscription',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  RESUMED_EVENT_SUBSCRIPTION: {
    module: ANALYTICS_MODULE.EVENTS,
    action: 'resumed_event_subscription',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_EVENT_SUBSCRIPTION_UPDATE_MODAL: {
    module: ANALYTICS_MODULE.EVENTS,
    action: 'opened_event_subscription_update_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_EVENT_SUBSCRIPTION_CREATE_MODAL: {
    module: ANALYTICS_MODULE.EVENTS,
    action: 'opened_event_subscription_create_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_EVENTS_DOCUMENTATION: {
    module: ANALYTICS_MODULE.EVENTS,
    action: 'opened_events_documentation',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_DEVELOPER_CONSOLE: {
    module: ANALYTICS_MODULE.EVENTS,
    action: 'opened_developer_console',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
